import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import MessageIcon from "@mui/icons-material/Message";
import CallIcon from "@mui/icons-material/Call";
import BusinessIcon from "@mui/icons-material/Business";
import VideocamIcon from "@mui/icons-material/Videocam";

export const instituteTypeOptions = [
  { value: "school", label: "School" },
  { value: "college", label: "College" },
  { value: "university", label: "University" },
  { value: "training_center", label: "Training Center" },
  { value: "polytechnic", label: "Polytechnic" },
  { value: "iti", label: "ITI" },
  { value: "research_institute", label: "Research Institute" },
  { value: "book_distributor", label: "Book Distributor" },
  { value: "group_of_schools", label: "Group of Schools" },
  { value: "business_associate", label: "Business Associate" },
  { value: "other", label: "Other" },
];

export const priorityOptions = [
  { value: "low", label: "Low" },
  { value: "medium", label: "Medium" },
  { value: "high", label: "High" },
  { value: "urgent", label: "Urgent" },
];

export const statusOptions = [
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "on_hold", label: "On Hold" },
  { value: "yet_to_begin", label: "Yet To Begin" },
];

export const instrumentTypeOptions = [
  { value: "dd", label: "DD" },
  { value: "cheque", label: "Cheque" },
  { value: "od", label: "OD" },
  { value: "online", label: "Online (NEFT/RTGS)" },
];

export const trainingTypeOptions = [
  { value: "training", label: "Training" },
  { value: "train_the_trainer", label: "Train The Trainer" },
  { value: "initial_training", label: "Initial Training" },
  { value: "refresher_training", label: "Refresher Training" },
  { value: "classroom_observation", label: "Class Room Observation" },
  { value: "general_visit", label: "General Visit to the School" },
  { value: "parents_orientation", label: "Parents' Orientation" },
  {
    value: "introduction_to_new_features",
    label: "Introduction to New Features",
  },
  { value: "crisis_handling_session", label: "Crisis Handling Session" },
];

export const trainingModeOptions = [
  { value: "online", label: "Online" },
  { value: "offline", label: "Offline" },
  { value: "hybrid", label: "Hybrid" },
];

export const trainingStatusOptions = [
  { value: "not_started", label: "Not Started" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "on_hold", label: "On Hold" },
  { value: "tentative", label: "Tentative" },
];

export const weekDaysOptions = [
  { number: 0, label: "Sunday" },
  { number: 1, label: "Monday" },
  { number: 2, label: "Tuesday" },
  { number: 3, label: "Wednesday" },
  { number: 4, label: "Thursday" },
  { number: 5, label: "Friday" },
  { number: 6, label: "Saturday" },
];

export const customizeViewOptions = [
  { value: "trainer", label: "Trainer" },
  { value: "project", label: "Project" },
  { value: "institute", label: "Institute" },
  { value: "title", label: "Training" },
];

export const designationOptions = [
  { value: "principal", label: "Principal" },
  { value: "director", label: "Director" },
  { value: "coordinator", label: "Coordinator" },
  { value: "administrator", label: "Administrator" },
  { value: "techsupport", label: "Technical Support" },
  { value: "teacher", label: "Teacher" },
  { value: "staff", label: "Staff" },
  { value: "others", label: "Others" },
];

export const repositoryOptions = [
  { value: "project", label: "Project" },
  { value: "training", label: "Training" },
  { value: "train_the_trainer", label: "Train The Trainer" },
  { value: "financial_document", label: "Financial Document" },
  { value: "other_document", label: "Other Document" },
  { value: "miscellaneous", label: "Miscellaneous" },
  { value: "general", label: "General" },
];

export const leaveOptions = [
  { value: "approved", label: "Approved" },
  { value: "pending", label: "Pending" },
  { value: "rejected", label: "Rejected" },
];

export const scheduleTypeOptions = [
  { value: "assessment", label: "Assessment" },  
  { value: "certification_exam", label: "Certification Exam" },
  { value: "curriculum_design", label: "Curriculum Design" },  
  { value: "data_entry", label: "Data Entry" },
  { value: "feedback_session", label: "Feedback Session" },
  { value: "hotel_stay", label: "Hotel Stay" },
  { value: "holiday", label: "Holiday" },
  { value: "head_office_visit", label: "Head Office Visit" },
  { value: "leave", label: "Leave" },
  { value: "meeting", label: "Meeting" },
  { value: "observation_session", label: "Observation Session" },
  { value: "pre_assessment", label: "Pre Assessment" },
  { value: "post_assessment", label: "Post Assessment" },
  { value: "remote_support", label: "Remote Support" }, 
  { value: "self_learning", label: "Self Learning" },
  { value: "seminar", label: "Seminar" },
  { value: "travel_outstation", label: "Travel – Outstation" },
  { value: "travel_local", label: "Travel – Local" }
];

export const scheduleStatusOptions = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "on_hold", label: "On Hold" },
];

export const salesTypeOptions = [
  { value: "all", label: "All" },
  { value: "lead", label: "Lead" },
  { value: "customer", label: "Customer" },
];

export const salesStatusColors = [
  { label: "new", value: "#3B82F6" },
  { label: "cold", value: "#94A3B8" },
  { label: "warm", value: "#F59E0B" },
  { label: "hot", value: "#EF4444" },
  { label: "closed", value: "#4B5563" },
  { label: "converted", value: "#60b864" },
];

export const communicationChannels = [
  { label: "Message", value: <MessageIcon /> },
  { label: "Meeting", value: <BusinessIcon /> },
  { label: "Call", value: <CallIcon /> },
  { label: "Video Meet", value: <VideocamIcon /> },
  { label: "Whatsapp", value: <WhatsAppIcon /> },
];

export const salesStatusOptions = [
  { value: "all", label: "All" },
  { value: "cold", label: "Cold" },
  { value: "warm", label: "Warm" },
  { value: "hot", label: "Hot" },
];

export const salesPriorityOptions = [
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

export const salesActivityStatusOptions = [
  { value: "pending", label: "Pending" },
  { value: "checked_in", label: "Checked In" },
  { value: "engaged", label: "Engaged" },
  { value: "completed", label: "Completed" },
];

export const institutionStageOptions = [
  { value: "in_progress", label: "In Progress" },
  { value: "follow_up", label: "Follow-up" },
  { value: "demo_scheduled", label: "Demo Scheduled" },
  { value: "demo_done", label: "Demo Done" },
  { value: "converted", label: "Converted" },
  { value: "not_interested", label: "Not Interested" },
];

export const instituteSourceOptions = [
  { value: "website", label: "Website" },
  { value: "email_marketing", label: "Email Marketing" },
  { value: "referral", label: "Referral" },
  { value: "customer_referral", label: "Customer Referral" },
  { value: "event", label: "Event" },
  { value: "walk_in", label: "Walk-in" },
];

export const tilePermissions = [
  { role: "salesadmin", tiles: ["sales","employee"] },
  { role: "salesperson", tiles: ["sales","employee"] },
  { role: "projectassistant", tiles: ["training","employee"] },
  { role: "projectcoordinator", tiles: ["training","employee"] },
  { role: "trainer", tiles: ["training"] },
  { role: "client", tiles: ["client"] },
  { role: "projectowner", tiles: ["training"] },
  { role: "admin", tiles: ["admin", "hr", "sales", "training"] },
  { role: "hradmin", tiles: ["hr"] },
  { role: "hrexecutive", tiles: ["hr"] },
  { role: "reportingmanager", tiles: ["hr"] },
  { role: "employee", tiles: ["employee"] },
  { role: "techadmin", tiles: ["hr"] },
];

export const adjustmentTypeOptions = [
  { value: "manual_adjustment", label: "Manual Adjustment" },
  { value: "year_end_process", label: "Year end process" },
  { value: "monthly_credit", label: "Monthly credit" },
];

export const leaveStatusFilter = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" },
];

export const regularizationTypes = [
  {
    value: "work_from_home",
    label: "Work From Home",
  },
  {
    value: "on_tour",
    label: "On Tour",
  },
  {
    value: "training",
    label: "Training",
  },
  {
    value: "official_work",
    label: "Official Work",
  },
  {
    value: "late_coming",
    label: "Late Coming",
  },
  {
    value: "early_going",
    label: "Early Going",
  },
];

export const correctionTypes = [
  {
    value: "in_punch",
    label: "In Punch",
  },
  {
    value: "out_punch",
    label: "Out Punch",
  },
  {
    value: "in_out_punch",
    label: "In and Out Punch",
  },
];

export const extraWorkingReasons = [
  {
    value: "as_per_need",
    label: "As Per Need",
  },
  {
    value: "urgent_work",
    label: "Urgent Work",
  },
  {
    value: "project_deadline",
    label: "Project Deadline",
  },
  {
    value: "workload_requirement",
    label: "Workload Requirement",
  },
  {
    value: "other",
    label: "Other",
  },
];

export const referenceTypeOptions = [
  { value: "manual_adjustment", label: "Manual Adjustment" },
  { value: "leave_application", label: "Leave Application" },
  { value: "leave_encashment", label: "Leave Encashment" },
  { value: "carry_forward", label: "Carry Forward" },
  { value: "attendance_regularization_request", label: "Attendance Regularization Request" },
  { value: "hr_assigned_policy", label: "HR Assigned Policy" },
  { value: "approved_leave_cancelled", label: "Approved Leave Cancelled" }
];

export const languageOptions = [
  { value: "english", label: "ENGLISH" },
  { value: "french", label: "FRENCH" },
  { value: "spanish", label: "SPANISH" },
  { value: "hindi", label: "HINDI" },
  { value: "sanskrit", label: "SANSKRIT" },
];

export const itemTypeOptions = [
  { value: "courseware", label: "COURSEWARE" },
  { value: "trainer_manual", label: "TRAINER MANUAL" },
  { value: "certificates", label: "CERTIFICATES" },
  { value: "flash_card", label: "FLASH CARD" },
];

export const itemCategoryOptions = [
  { value: "junior", label: "JUNIOR" },
  { value: "senior", label: "SENIOR" },
  { value: "wonderbook", label: "WONDERBOOK" },
];

export const uomOptions = [
  { value: "piece", label: "Piece" },
  { value: "set", label: "Set" },
  { value: "box", label: "Box" },
];

export const locationTypeOptions = [
  { value: 'HEAD_OFFICE', label: 'HEAD OFFICE'},
  { value: 'BRANCH', label: 'BRANCH'},
  { value: 'THIRD_PARTY', label: 'THIRD PARTY'},
  { value: 'WAREHOUSE', label: 'WAREHOUSE'},
  { value: 'PRINTER', label: 'PRINTER'}  
];

export const transactionTypeOptions = [    
    { value: "OPENING", label: "OPENING" },
    { value: "DISPATCH", label: "DISPATCH" },
    { value: "PRINTED", label: "PRINTED" },
    { value: "TRANSFER", label: "TRANSFER" },
    { value: "ADJUSTMENT", label: "ADJUSTMENT" },    
    { value: "DAMAGE", label: "DAMAGE" },
    { value: "RETURN", label: "RETURN" }    
];

export const dispatchMediumOptions = [    
    { value: "COURIER", label: "Courier / Express Cargo" },
    { value: "VEHICLE", label: "Company Vehicle" },
    { value: "HAND_DELIVERY", label: "Hand Delivery" }
];


export const salesScheduleTypeOptions = [  
  { value: "travel_outstation", label: "Travel – Outstation" },
  { value: "travel_local", label: "Travel – Local" },
  { value: "meeting", label: "Meeting" },
  { value: "event", label: "Event" },
  { value: "head_office_visit", label: "Head Office Visit" },
  { value: "visit", label: "Visit" },
  { value: "other", label: "Other" }
];

export const salesScheduleStatusOptions = [
  { value: "planned", label: "Planned" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export const zoneOptions = [
  { value: "north", label: "North" },
  { value: "south", label: "South" },
  { value: "east", label: "East" },
  { value: "west", label: "West" },
  { value: "central", label: "Central" },
  { value: "north_east", label: "North-East" }    
];
